import React, { type FC } from "react";

import { cn } from "@utilities/helper";

const MastercardIcon: FC<{ className?: string }> = ({ className }) => (
  <svg
    className={cn("", className)}
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 1000 618"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path fill="#EB001B" d="m308,0a309,309 0 1,0 2,0z" />
    <path fill="#F79E1B" d="m690,0a309,309 0 1,0 2,0z" />
    <path fill="#FF5F00" d="m500,66a309,309 0 0,0 0,486 309,309 0 0,0 0-486" />
  </svg>
);

export default MastercardIcon;
